module.exports = __webpack_public_path__ + "static/sample-3-0f26312725de7ada50179ee44a0daac6.png";